import EnvironmentService, { Environment } from 'app/lib/services/EnvironmentService'
import * as React from 'react'

import KTag from '../../DataDisplay/KTag'

const ENV_CONFIG = {
  [Environment.Prod]: {
    name: 'Prod',
    color: 'blue'
  },
  [Environment.Demo]: {
    name: 'Demo',
    color: 'blue'
  },
  [Environment.Staging]: {
    name: 'Stg',
    color: 'yellow'
  },
  [Environment.Dev]: {
    name: 'Dev',
    color: 'green'
  },
  [Environment.Test]: {
    name: 'Test',
    color: 'red'
  }
}

type Props = {
  className?: string
}
const EnvironmentTag: React.FC<Props> = ({ className }) => {
  if (EnvironmentService.isProduction()) {
    return null
  }

  const env = (EnvironmentService.getEnvValue('ENV') as Environment) || Environment.Dev
  const config = ENV_CONFIG[env]
  return <KTag text={config.name?.toUpperCase()} color={config.color} className={className} />
}

export default EnvironmentTag
